import {
  ActivityIndicator,
  StyleSheet,
  Text,
  TextInput,
  View
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { Formik } from 'formik'
import Card from '../../shared/card/Card'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import CustomButton from '../../shared/button/Button'
import { useFormsStore } from '../../../stores/onboarding'
import * as yup from 'yup'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'

const VaInformationForm = ({ navigation, route }) => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params
  const personalstore = usePersonalStore()
  const intializeStore = useInitializeStore()
  const { loading, postvaonline } = useFormsStore()
  const intialValues = {
    subtotalofpersonalExemptions: "",
    subtotalforAge: "",
    totalExemptions: "",
    additionalwithholding: '',
    va_withholding_exempt: '',
    smcra_msra_exempt: ''
  }
  const w4schema = () => {
    const baseSchema = {
      subtotalofpersonalExemptions: yup.string()
        .nullable(),
      subtotalforAge: yup.string().nullable(),
      additionalwithholding: yup
        .string()
        .nullable(),
      va_withholding_exempt: yup
        .string()
        .nullable(),
      smcra_msra_exempt: yup
        .string()
        .nullable()
    }
    return yup.object(baseSchema)
  }
  const schema = w4schema()


  const options2 = [
    { key: 1, value: "No" },
    { key: 2, value: "Yes" }
  ]
  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'VA Withholding Taxation'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={schema}
          onSubmit={async (values, actions) => {

            const data = {
              entityId: personalstore?.personalData?.entityId,
              essUserKey: intializeStore?.initializeData?.userkey,
              essObKey: essUserOnBoardingKey,
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              completeOnline: mode === 'upload' ? false : true,
              personalExemptions: personalstore?.personalData?.maritalStatusValue == "S" ? 0 : 1,
              subTotalAgeExemptions: values?.subtotalforAge ? values?.subtotalforAge : null,
              totalExemptions: values?.totalExemptions ? values?.totalExemptions : null,
              additionalWithholding: values?.additionalwithholding ? values?.additionalwithholding : null,
              vawithholdingExempt: values?.va_withholding_exempt ? values?.va_withholding_exempt : null,
              smcrawithholdingExempt: values?.smcra_msra_exempt ? values?.smcra_msra_exempt : null,
              TotalPersonalExemptions: values?.subtotalofpersonalExemptions ? values?.subtotalofpersonalExemptions : null,
            }
            const response = await postvaonline(data)
            if (response?.success) {
              if (mode === 'online') {
                navigation.navigate('VaInformationOnline', {
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                  completeOnline: mode === 'upload' ? false : true,
                  subtotalpersonalexemption: values?.subtotalofpersonalExemptions,
                  subtotalforage: values?.subtotalforAge,
                })
              } else {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              }

            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <Card>



              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ width: '70%', justifyContent: 'center' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {'Subtotal of Personal Exemptions - line 4 of the Personal Exemption Worksheet '}
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <TextInput
                    style={[globalStyles.input, globalStyles.inputLight]}
                    value={props.values.subtotalofpersonalExemptions}
                    keyboardType="numeric"
                    onChangeText={(text) => {
                      if (text === '' || /^\d+$/.test(text)) {
                        props.handleChange('subtotalofpersonalExemptions')(text)
                      }
                    }}
                  />
                  {props.touched.subtotalofpersonalExemptions &&
                    props.errors.subtotalofpersonalExemptions && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.subtotalofpersonalExemptions}
                      </Text>
                    )}
                </View>
              </View>

              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ width: '70%', justifyContent: 'center' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {'Subtotal of Exemptions for Age and Blindness line 7 of the Personal Exemption Worksheet '}
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <TextInput
                    style={[globalStyles.input, globalStyles.inputLight]}
                    value={props.values.subtotalforAge}
                    keyboardType="numeric"
                    onChangeText={(text) => {
                      if (text === '' || /^\d+$/.test(text)) {
                        props.handleChange('subtotalforAge')(text)
                      }
                    }}
                  />
                  {props.touched.subtotalforAge &&
                    props.errors.subtotalforAge && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.subtotalforAge}
                      </Text>
                    )}
                </View>
              </View>
              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ width: '70%', justifyContent: 'center' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {'Enter Total Allowances'}
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <TextInput
                    style={[globalStyles.input, globalStyles.inputLight]}
                    value={props.values.totalExemptions}
                    keyboardType="numeric"
                    onChangeText={(text) => {
                      if (text === '' || /^\d+$/.test(text)) {
                        props.handleChange('totalExemptions')(text)
                      }
                    }}
                  />
                  {props.touched.totalExemptions &&
                    props.errors.totalExemptions && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.totalExemptions}
                      </Text>
                    )}
                </View>
              </View>
              {Number(props.values.va_withholding_exempt) !== 1 && Number(props.values.smcra_msra_exempt) !== 1 && (
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter the amount of additional withholding'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.additionalwithholding}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('additionalwithholding')(text)
                        }
                      }}
                    />
                    {props.touched.additionalwithholding &&
                      props.errors.additionalwithholding && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.additionalwithholding}
                        </Text>
                      )}
                  </View>
                </View>
              )}
              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ justifyContent: 'center', width: '65%' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {'I certify that I am not subject to Virginia withholding. l meet the conditions set forth in the instructions'}
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <SelectKeyValue
                    title="I certify that I am not subject to Virginia withholding. l meet the conditions set forth in the instructions"
                    options={options2}
                    selectedOption={mapSelectValue(
                      options2,
                      props.values.va_withholding_exempt
                    )}
                    onSelect={(option: any) => {
                      const val = option - 1
                      props.setFieldValue('va_withholding_exempt', val)
                      if (val === 1) {
                        props.setFieldValue('additionalwithholding', '')
                      }
                    }}
                    textColor="primary"
                  />
                  {props.touched.va_withholding_exempt &&
                    props.errors.va_withholding_exempt && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.va_withholding_exempt}
                      </Text>
                    )}
                </View>
              </View>
              <View
                style={[
                  globalStyles.hDirection,
                  globalStyles.hBetweenItems,
                  globalStyles.mb2
                ]}
              >
                <View style={{ justifyContent: 'center', width: '65%' }}>
                  <Text
                    style={[
                      globalStyles.inputLabel,
                      globalStyles.inputLabelLarge,
                      globalStyles.inputLabelPrimary
                    ]}
                  >
                    {'I certify that I am not subject to Virginia withholding. l meet the conditions set forth Under the Service member Civil Relief Act, as amended by the Military Spouses Residency Relief Act'}
                  </Text>
                </View>
                <View style={{ width: '28%', overflow: 'hidden' }}>
                  <SelectKeyValue
                    title="Are you exempt from Virginia withholding under the Service Members Civil Relief Act and the Military Spouses Residency Relief Act"
                    options={options2}
                    selectedOption={mapSelectValue(
                      options2,
                      props.values.smcra_msra_exempt
                    )}
                    onSelect={(option: any) => {
                      const val = option - 1
                      props.setFieldValue('smcra_msra_exempt', val)
                      if (val === 1) {
                        props.setFieldValue('additionalwithholding', '')
                      }
                    }}
                    textColor="primary"
                  />
                  {props.touched.smcra_msra_exempt &&
                    props.errors.smcra_msra_exempt && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.smcra_msra_exempt}
                      </Text>
                    )}
                </View>
              </View>

              {loading ? (
                <ActivityIndicator />
              ) : (
                <View style={{ margin: 10 }}>
                  <CustomButton
                    text={mode === 'upload' ? 'Submit Information' : 'Next'}
                    onPress={props.handleSubmit}
                  />
                </View>
              )}
            </Card>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}

export default VaInformationForm

const styles = StyleSheet.create({})
